<template>
    <!-- 公司文化 -->
    <div class="main">
        <div class="content">
            <sub-title
                title="相关下载"
                class="title"
            ></sub-title>

            <div class="inner-content">
                <table class="table">
                    <tr>
                        <td>#</td>
                        <td>文件名称</td>
                        <td>下载</td>
                        <td>使用范围</td>
                    </tr>

                    <tr v-for="(row, index) in tableData" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{row.title}}</td>
                        <td>
                            <a :href="row.urlname" target="_blank">免费下载</a>
                        </td>
                        <td>
                            {{row.infoa || '-'}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from '../../index/component/sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            tableData: [
                {
                    title: "投标文件制作工具",
                    urlname: "http://www.hbidding.com/zbdownloadtool/Bid.zip",
                    infoa: "投标单位"
                },
                {
                    title: "电子招投标数字证书助手",
                    urlname: "http://helper.pasiatec.com/client/HEBCA-helper-ztb.zip",
                    infoa: null
                },
                {
                    title: "惠招标签章工具",
                    urlname: "http://www.hbidding.com/zbdownloadtool/CaSeal.zip",
                    infoa: null
                },
                {
                    title: "IE11下载地址",
                    urlname: "https://www.microsoft.com/zh-cn/download/details.aspx?id=40901",
                    infoa: "投标单位；代理机构"
                },
                {
                    title: "招标文件制作工具",
                    urlname: "http://www.hbidding.com/zbdownloadtool/Tender.zip",
                    infoa: "代理机构"
                },
                {
                    title: "CA办理及绑定说明",
                    urlname: "http://www.hbidding.com/zbdownloadtool/cahelp.pdf",
                    infoa: "投标单位；代理机构"
                },
                {
                    title: "向日葵远程工具",
                    urlname: "https://sunlogin.oray.com/download?categ=personal",
                    infoa: null
                },
                {
                    title: "河北腾翔电子签章客户端",
                    urlname: "http://www.hbidding.com/zbdownloadtool/河北腾翔电子签章客户端.zip",
                    infoa: null
                },
                {
                    title: "设置惠招标可信任站点",
                    urlname: "http://www.hbidding.com/upload/15718974688931.zip",
                    infoa: null
                },
                {
                    title: "CA在线办理",
                    urlname: "http://hebcaonline.hebca.com:9001/Hebca/certbussconduct/entry.action?onlineType=4&projectType=zbrhah&cztype=1",
                    infoa: null
                },
                {
                    title: "谷歌下载地址",
                    urlname: "https://www.google.cn/chrome/",
                    infoa: "投标单位；代理机构"
                },
                {
                    title: "省公共资源认证ca",
                    urlname: "http://publicservice.hebpr.cn:8181/#",
                    infoa: null
                }
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.main {
    width: 100%;
    background-image: linear-gradient(#EAF2FF, white);
    padding-top: 93px;

    .inner-content {
        width: 100%;
        display: flex;
        padding: 40px;
        margin-top: 65px;
        background: #fff;

        .table{
            width: 100%;
            border-left: 1px solid #ebeef5;
            border-top: 1px solid #ebeef5;

            tr{
                
            }

            td{
                padding: 12px 10px;
                border-right: 1px solid #ebeef5;
                border-bottom: 1px solid #ebeef5;
            }

            a {
                color: #107eec;
            }
        }
    }
}
</style>
